<template>
    <div class="flex flex-col justify-center w-full" :class="isCentered ? 'items-center' : 'items-start'">
      <KButton theme="primary" textOnly class="mt-6 bold" @click="openModal"   :aria-label="`Open ${linkTitle} photochromatic preview modal`">
          {{ linkTitle }}
          <template #append>
            <KIcon name="link" class="h-3 ml-2 fill-current text-primary-dark"/>
          </template>
        </KButton>
      <KModal :variant="modalVariant" v-if="isModalVisible" @close="isModalVisible = false ">
          <template #content>
              <Photochromatic
                  :leftImg="left.url"
                  :rightImg="right.url"
                  :leftAlt="left.alt"
                  :rightAlt="right.alt"
                  :rightText="right.label"
                  :leftText="left.label"/>
          </template>
      </KModal>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue'
import KButton from '@/components/atoms/Button/index.vue';
import KModal from '@/components/atoms/Modal/KModal.vue';
import KIcon from '@/components/atoms/Icon/index.vue';
import PhotochromaticModel from '@/model/Photochromatic.ts';
import Photochromatic from '@/components/atoms/Photochromatic/index.vue';
import useScreen from '@/hooks/useScreen'

export default defineComponent({
  name: 'PhotochromaticModal',
  props: {
    photochromatic: {
      type: Object as () => PhotochromaticModel,
      required: true,
      validator: (value: PhotochromaticModel) => value instanceof PhotochromaticModel
    },
    isCentered: {
      type: Boolean,
      default: false
    }
  },
  components: {
    KButton,
    KIcon,
    KModal,
    Photochromatic
  },
  setup (props) {
    const { isSmScreen } = useScreen()
    const modalVariant = computed(() => isSmScreen.value ? 'base' : 'transparent')

    const isModalVisible = ref(false)
    function openModal () {
      isModalVisible.value = true
    }

    return { isModalVisible, modalVariant, ...props.photochromatic, openModal }
  }
})
</script>
